<template>
  <div>
    <v-form @submit.prevent="createLanguage">
      <v-row
        align="center"
        class="mb-2"
      >
        <v-col
          cols="12"
          sm="4"
        >
          <v-autocomplete
            v-model="createForm.language_code"
            :label="$t('Select language')"
            outlined
            :items="availableFaqLanguages"
            :loading="createForm.processing"
            :disabled="createForm.processing"
            item-text="name"
            item-value="code"
            autocomplete="off"
            hide-details
            dense
          />
        </v-col>
        <v-col
          cols="12"
          sm="4"
        >
          <v-btn
            color="primary"
            type="submit"
            :loading="createForm.processing"
            :disabled="! createForm.language_code || createForm.processing"
          >
            {{ $t('Add language') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <v-list-item
      v-for="language in faqLanguages"
      :key="language.code"
      class="pl-0 pr-0"
    >
      <template #default>
        <v-list-item-content>
          <v-list-item-title>{{ language.formatted }}</v-list-item-title>
        </v-list-item-content>

        <v-list-item-action>
          <v-switch
            v-model="language.enabled"
            class="enable-language-switch"
            :label="$t('Enabled')"
            @change="value => handleLanguageEnabledChange(language.code, value)"
          />
        </v-list-item-action>

        <v-list-item-action>
          <v-btn
            icon
            color="primary"
            @click="deleteLanguage(language)"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-list-item-action>
      </template>
    </v-list-item>
  </div>
</template>

<script>
export default {
  props: {
    faqId: {
      type: Number,
      required: true
    },
    availableFaqLanguages: {
      type: Array,
      required: true
    },
    faqLanguages: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      createForm: this.$inertia.form({
        language_code: ''
      })
    }
  },

  methods: {
    createLanguage() {
      const url = this.route('faq-language.store', {
        faq: this.faqId,
      });

      this.createForm.post(url, {
        preserveState: true,
        preserveScroll: true,
        onSuccess: () => {
          this.createForm.reset();
          this.$emit('language:created');
        }
      })
    },

    async deleteLanguage(language) {
      const confirmed = await this.$root.$confirm(
        this.$t(`Remove language`),
        this.$t(`Are you sure you want to remove '{language}'? All translations will be lost.`, { language: language.name })
      );

      if (! confirmed) {
        return;
      }

      const url = this.route('faq-language.destroy', {
        faq: this.faqId,
        languageCode: language.code
      });

      this.$inertia.delete(url, {
        preserveState: false,
        preserveScroll: true,
      });
    },

    handleLanguageEnabledChange(languageCode, value) {
      const url = this.route('faq-language.update', { faq: this.faqId, languageCode });

      this.$inertia.patch(url, {
        enabled: value
      }, {
        preserveState: true,
        preserveScroll: true
      });
    }
  }
}
</script>


<style>
  .enable-language-switch label {
    font-size: .75em;
    padding-left: 5px;
  }
</style>